export default __webpack_public_path__ + "68e060898aabcae6bf037d5fdd9332f1.svg";